<style scoped>
.round-table-image {
  height: 112px;
  width: 118px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.round-table-image img {
  max-width: 100%;
  max-height: 100%;
}
.sponsor-round-table-wrapper {
  border: 1px solid #dfdfdf;
  background: #fbfcfe;
  border-radius: 6px;
  overflow: hidden;
}
.sponsor-to-round-table-join-button a {
  height: 40px;
  width: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #58a948;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}
.contact-newicons ul {
  margin: 0;
  padding: 0;
}
.contact-newicons ul li {
  list-style: none;
  display: inline-flex;
  width: 35px;
  height: 35px;
  margin-right: 5px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.contact-newicons ul li img {
  height: 22px;
  width: 22px;
}
.rounded-new {
  border-radius: 50%;
}
.sponsor-round-table-right {
  cursor: pointer !important;
}
</style>
<template>
  <div v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section
      id="sectionId"
      class="
        sponsors-list-wrapper
        d-flex
        body-content
        exhibitor-details
        new-sponsor-details new_sponsor_details
      "
    >
      <div class="container-fluid">
        <h1 id="headerText" class="page-head text-uppercase">
          <span class="pr-2" title="Back">
            <router-link
              id="anchExh"
              to="/sponsors"
              data-tag="sponsorsListBAck"
            >
              <!-- <a href="#" id="anchExh" v-on:click.prevent="goBack"> -->
              <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                fill="#242432"
                width="24px"
                height="24px"
                viewBox="0 0 31.494 31.494"
                style="enable-background: new 0 0 31.494 31.494"
                xml:space="preserve"
              >
                <path
                  style="fill: #1e201d"
                  d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
              <!-- </a> -->
            </router-link>
          </span>
          {{ headerText }}
        </h1>
        <div
          class="sponsor-details-info"
          id="divsponsor"
          style="display: block"
        >
          <div class="banner-bottom-strip">
            <div class="row align-items-center">
              <div class="col-md-12">
                <div
                  class="
                    banner-bottom-strip-left
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <div class="media align-items-center" v-bind:d="id">
                    <span class="logo-hld" id="exhi_logo">
                      <img
                        v-bind:src="Image != '' ? Image : defaultLogo"
                        v-bind:alt="Name"
                      />
                    </span>
                    <div class="media-body ml-3">
                      <h4 id="exhi_name">
                        {{ Name }}

                        <span class="pl-3">
                          <v-tooltip v-if="!isBookmarked" bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                size="32"
                                color="black"
                                @click="addBookMark()"
                                style="cursor: pointer"
                                v-on="on"
                                >bookmark_border</v-icon
                              >
                            </template>
                            <span>Bookmark</span>
                          </v-tooltip>
                          <v-tooltip v-else bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                size="32"
                                color="success"
                                @click="addBookMark()"
                                style="cursor: pointer"
                                v-on="on"
                                >bookmark</v-icon
                              >
                            </template>
                            <span>Bookmarked</span>
                          </v-tooltip>
                        </span>
                      </h4>

                      <p
                        v-if="Category != null && Category.CategoryName != null"
                        class="sponsor-category pb-md-3"
                      >
                        <span class>{{ Category.CategoryName }}</span>
                      </p>
                      <!--- desktop contact---->
                      <div class="new-addendee-details d-md-block d-none">
                        <div class="contact-details">
                          <ul class="p-0 m-0">
                            <li
                              id="modalEmail"
                              class="email"
                              v-show="IsShowEmailIcon"
                            >
                              <a :href="'mailto:' + Email" target="_blank">{{
                                Email
                              }}</a>
                            </li>
                            <li
                              id="modalPhone"
                              class="ph-no"
                              v-show="IsShowMobileIcon"
                            >
                              <a :href="'tel:' + Phone" target="_blank">{{
                                Phone
                              }}</a>
                            </li>
                            <li
                              id="modalWebsite"
                              class="website"
                              v-show="IsShowWebsiteIcon"
                            >
                              <a
                                target="_blank"
                                data-original-title="Website"
                                v-bind:href="Website"
                                data-tag="sponsorWebsite"
                                >{{ Website }}</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="social-icon d-flex pt-md-2 d-none">
                        <a
                          id="anchFacebook"
                          data-tag="Facebook"
                          v-if="facebook != ''"
                          v-on:click="onClickHandler"
                          :href="facebook"
                          data-toggle="tooltip"
                          data-original-title="Click to Open Facebook"
                          target="_blank"
                        >
                          <span id="spnFacebook">
                            <i
                              class="fa fa-facebook"
                              id="iFacebook"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </a>
                        <a
                          id="anchTwitter"
                          data-tag="Twitter"
                          v-if="twitter != ''"
                          v-on:click="onClickHandler"
                          :href="twitter"
                          data-toggle="tooltip"
                          data-original-title="Click to Open Twitter"
                          target="_blank"
                        >
                          <span id="spnTwitter">
                            <i
                              class="fa fa-twitter"
                              id="iTwitter"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </a>
                        <a
                          id="anchLinkedIn"
                          data-tag="LinkedIn"
                          v-on:click="onClickHandler"
                          v-if="linkedIn != ''"
                          :href="linkedIn"
                          data-toggle="tooltip"
                          data-original-title="Click to Open LinkedIn"
                          target="_blank"
                        >
                          <span id="spnLinkedIn">
                            <i
                              class="fa fa-linkedin"
                              id="iLinkedIn"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </a>
                        <a
                          id="anchInstagram"
                          data-tag="Instagram"
                          v-on:click="onClickHandler"
                          v-if="instagram != ''"
                          :href="instagram"
                          data-toggle="tooltip"
                          data-original-title="Click to Open Instagram"
                          target="_blank"
                        >
                          <span id="anchInstagram">
                            <i
                              class="fa fa-instagram"
                              id="iInstagram"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </a>
                      </div>

                      <!---desktop contact end---->
                    </div>
                  </div>
                  <!-- --contact mobile-- -->
                  <div class="new-addendee-details d-md-none d-block mob-full">
                    <div class="contact-details">
                      <ul class="p-0 m-0">
                        <li
                          id="modalEmail"
                          class="email"
                          v-show="IsShowEmailIcon"
                        >
                          <a :href="'mailto:' + Email" target="_blank">{{
                            Email
                          }}</a>
                        </li>
                        <li
                          id="modalPhone"
                          class="ph-no"
                          v-show="IsShowMobileIcon"
                        >
                          <a :href="'tel:' + Phone" target="_blank">{{
                            Phone
                          }}</a>
                        </li>
                        <li
                          id="modalWebsite"
                          class="website"
                          v-show="IsShowWebsiteIcon"
                        >
                          <a
                            target="_blank"
                            data-original-title="Website"
                            v-bind:href="Website"
                            data-tag="sponsorWebsite"
                            >{{ Website }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="social-icon d-flex pt-2 d-md-none mob-full">
                    <a
                      id="anchFacebook"
                      data-tag="Facebook"
                      v-if="facebook != ''"
                      v-on:click="onClickHandler"
                      :href="facebook"
                      data-toggle="tooltip"
                      data-original-title="Click to Open Facebook"
                      target="_blank"
                    >
                      <span id="spnFacebook">
                        <i
                          class="fa fa-facebook"
                          id="iFacebook"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </a>
                    <a
                      id="anchTwitter"
                      data-tag="Twitter"
                      v-if="twitter != ''"
                      v-on:click="onClickHandler"
                      :href="twitter"
                      data-toggle="tooltip"
                      data-original-title="Click to Open Twitter"
                      target="_blank"
                    >
                      <span id="spnTwitter">
                        <i
                          class="fa fa-twitter"
                          id="iTwitter"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </a>
                    <a
                      id="anchLinkedIn"
                      data-tag="LinkedIn"
                      v-on:click="onClickHandler"
                      v-if="linkedIn != ''"
                      :href="linkedIn"
                      data-toggle="tooltip"
                      data-original-title="Click to Open LinkedIn"
                      target="_blank"
                    >
                      <span id="spnLinkedIn">
                        <i
                          class="fa fa-linkedin"
                          id="iLinkedIn"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </a>
                    <a
                      id="anchInstagram"
                      data-tag="Instagram"
                      v-on:click="onClickHandler"
                      v-if="instagram != ''"
                      :href="instagram"
                      data-toggle="tooltip"
                      data-original-title="Click to Open Instagram"
                      target="_blank"
                    >
                      <span id="anchInstagram">
                        <i
                          class="fa fa-instagram"
                          id="iInstagram"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </a>
                  </div>

                  <!-- --contact mobile end-- -->
                  <RoundTable
                    v-for="table in allRoundTables"
                    :key="'rt_' + table.TableId"
                    pageId="sprt"
                    showHeader="false"
                    :table="table"
                    @JoinRT="JoinRT"
                    style="height: 185px; width: 140px"
                  >
                  </RoundTable>
                  <!--<div
                    v-for="roundtable in allRoundTables"
                    v-bind:key="roundtable.TableId"
                    id="dvMainRoundTable"
                    class="sponsor-round-table-right"
                    v-show="roundtable.IsTblVisible && false"
                  >
                    <div
                      class="sponsor-round-table-wrapper"
                      :data-tag="
                        'sponsordetails/' + roundtable.hostId + '/Roundtable'
                      "
                      @click="
                        JoinTable(
                          roundtable.hostId,
                          roundtable.TableId,
                          roundtable.IsVisible,
                          roundtable.IsTableFull,
                          roundtable.StreamingClient,
                          roundtable.Zoom_Detail
                        )
                      "
                    >
                      <div class="round-table-image">
                        <img
                          v-bind:src="roundtable.imgsrc"
                          v-bind:alt="roundtable.Name"
                        />
                      </div>
                      <div
                        v-bind:class="
                          roundtable.LabelCss +
                          ' sponsor-to-round-table-join-button'
                        "
                      >
                        <a href="javascript:void(0);">{{
                          roundtable.tableLabel
                        }}</a>
                      </div>
                    </div>
                  </div>-->
                  <!--<div
                    v-for="roundtable in allRoundTables"
                    v-bind:key="roundtable.id"
                    v-bind:class="
                      'col-lg-2 col-md-4 col-6 exhibitors-box-hld edit-table-btn ' +
                      roundtable.id
                    "
                    v-show="roundtable.IsTblVisible"
                  >
                    <div
                      class="new-exhibitors-box"
                      v-on:click="
                        JoinTable(
                          roundtable.hostId,
                          roundtable.TableId,
                          roundtable.IsVisible,
                          roundtable.IsTableFull,
                          roundtable.StreamingClient,
                          roundtable.Zoom_Detail
                        )
                      "
                      data-tag="joinRoundtablevideo"
                    >
                      <a>
                        <h3 data-toggle="tooltip" :title="roundtable.Name">
                          {{ roundtable.Name }}
                        </h3>
                        <div class="img-hld">
                          <img
                            v-bind:src="roundtable.imgsrc"
                            v-bind:alt="roundtable.Name"
                          />
                        </div>
                      </a>
                      <h4 v-bind:class="roundtable.LabelCss">
                        <a href="#">{{ roundtable.tableLabel }}</a>
                      </h4>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <!------tab area start---->
          <div class="speakers-detailstab session-list-wrapper pt-0">
            <ul role="tablist" class="nav nav-tabs text-uppercase">
              <li class="nav-item" v-show="IsShowDescriptionTab">
                <a
                  data-toggle="tab"
                  href="#description"
                  data-tag
                  :class="
                    currentTab == 'description' ? 'nav-link active' : 'nav-link'
                  "
                  >Description</a
                >
              </li>
              <li class="nav-item" v-show="IsShowContactsTab">
                <a
                  data-toggle="tab"
                  href="#contact"
                  data-tag
                  :class="
                    currentTab == 'contacts' ? 'nav-link active' : 'nav-link'
                  "
                  >Contacts</a
                >
              </li>
              <li class="nav-item" v-show="IsShowResources">
                <a
                  data-toggle="tab"
                  href="#Resources"
                  data-tag
                  :class="
                    currentTab == 'resources' ? 'nav-link active' : 'nav-link'
                  "
                  >Resources</a
                >
              </li>
            </ul>
          </div>
          <!------tabarea end---->
          <!----tab content---->
          <div class="tab-content mt-3">
            <!--description--->
            <div
              id="description"
              :class="
                currentTab == 'description' ? 'tab-pane active' : 'tab-pane'
              "
            >
              <!-- <h5 class>Description</h5> -->
              <p id="modalProfile" v-html="Profile" class="text-left"></p>
            </div>
            <!----contact---->
            <div
              id="contact"
              :class="
                currentTab == 'contacts'
                  ? 'tab-pane text-left active'
                  : 'tab-pane text-left'
              "
            >
              <!-- <h5 class>Contact(s)</h5> -->

              <div class="row pt-3">
                <div
                  class="col-lg-4 col-md-6"
                  v-for="contacts in MappedContacts"
                  v-bind:key="contacts.AttendeeId"
                >
                  <div
                    class="
                      custome-new-sponsor-details
                      d-flex
                      align-items-center
                      mb-2
                    "
                  >
                    <div
                     class="sp-details-img"
                      v-if="
                        contacts.ProfilePictureURL != undefined &&
                        contacts.ProfilePictureURL.length > 0
                      "
                    >
                      <img
                        v-bind:src="getCDNUrl(contacts.ProfilePictureURL)"
                        v-bind:alt="contacts.Name"
                        class="rounded-new mr-3"
                        style="width: 90px; height: 90px; border-radious: 50%"
                      />
                    </div>
                    <div v-else class="clsSponsorInitial">
                      {{ getInitials(contacts.Name) }}
                    </div>
                    <div class="sponsor-newdetails">
                      <h3>{{ contacts.Name }}</h3>
                      <p class="mb-0">{{ contacts.Company }}</p>
                      <p class="mb-0">{{ contacts.Designation }}</p>
                      <!-- <div class="contact-newicons">
                        <ul>
                          <li>
                            <img src="../assets/Images/icons/video3.svg" />
                          </li>
                          <li>
                            <a
                              v-on:click="onClickHandler"
                              :href="'mailto:' + contacts.Email"
                              target="_blank"
                              title="Email"
                              :data-tag="
                                'Email-' + contacts.Name + '-' + contacts.Name
                              "
                            >
                              <img
                                src="../assets/Images/icons/envelope2.svg"
                                data-toggle="tooltip1"
                                data-html="true"
                                :data-tag="
                                  'Email-' + contacts.Name + '-' + contacts.Name
                                "
                                title
                                data-original-title="Email"
                              />
                            </a>
                          </li>
                          <li><img src="../assets/Images/Meeting.svg" /></li>
                          <li><img src="../assets/Images/icons/chat.svg" /></li>
                        </ul>
                      </div> -->
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <!----resources---->
            <div
              id="Resources"
              :class="
                currentTab == 'resources'
                  ? 'tab-pane text-left active'
                  : 'tab-pane text-left'
              "
            >
              <!-- <h5 class>Resources</h5> -->
              <div class="row">
                <div
                  class="
                    p-md-3
                    mb-2
                    d-flex
                    align-items-center
                    col-md-4
                    mob-py-0
                  "
                  v-for="resource in Resources"
                  v-bind:key="resource"
                >
                  <div
                    class="
                      session-tab-innerBox
                      d-flex
                      align-items-center
                      full-width
                    "
                  >
                    <span class="logo-hld">
                      <svg
                        version="1.1"
                        id="Layer_1"
                        width="45"
                        fill="#242432"
                        height="45"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style="enable-background: new 0 0 512 512"
                        xml:space="preserve"
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M444.875,109.792L338.208,3.125c-2-2-4.708-3.125-7.542-3.125h-224C83.135,0,64,19.135,64,42.667v426.667	C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333v-352	C448,114.5,446.875,111.792,444.875,109.792z M341.333,36.417l70.25,70.25h-48.917c-11.76,0-21.333-9.573-21.333-21.333V36.417z M426.667,469.333c0,11.76-9.573,21.333-21.333,21.333H106.667c-11.76,0-21.333-9.573-21.333-21.333V42.667	c0-11.76,9.573-21.333,21.333-21.333H320v64C320,108.865,339.135,128,362.667,128h64V469.333z"
                              />
                              <path
                                d="M310.385,313.135c-9.875-7.771-19.26-15.76-25.51-22.01c-8.125-8.125-15.365-16-21.656-23.5	c9.813-30.323,14.115-45.958,14.115-54.292c0-35.406-12.792-42.667-32-42.667c-14.594,0-32,7.583-32,43.688	c0,15.917,8.719,35.24,26,57.698c-4.229,12.906-9.198,27.792-14.781,44.573c-2.688,8.052-5.604,15.51-8.688,22.406	c-2.51,1.115-4.948,2.25-7.302,3.427c-8.479,4.24-16.531,8.052-24,11.594C150.5,370.177,128,380.844,128,401.906	c0,15.292,16.615,24.76,32,24.76c19.833,0,49.781-26.49,71.656-71.115c22.708-8.958,50.938-15.594,73.219-19.75	c17.854,13.729,37.573,26.865,47.125,26.865c26.448,0,32-15.292,32-28.115c0-25.219-28.813-25.219-42.667-25.219	C337.031,309.333,325.49,310.604,310.385,313.135z M160,405.333c-6.094,0-10.219-2.875-10.667-3.427	c0-7.563,22.552-18.25,44.365-28.583c1.385-0.656,2.792-1.313,4.219-1.99C181.896,394.563,166.052,405.333,160,405.333z M234.667,214.354c0-22.354,6.938-22.354,10.667-22.354c7.542,0,10.667,0,10.667,21.333c0,4.5-3,15.75-8.49,33.313	C239.135,233.75,234.667,222.698,234.667,214.354z M242.844,329c0.667-1.854,1.313-3.729,1.938-5.625	c3.958-11.875,7.521-22.542,10.698-32.146c4.427,4.875,9.198,9.865,14.313,14.979c2,2,6.958,6.5,13.563,12.135	C270.208,321.208,256.219,324.76,242.844,329z M362.667,334.552c0,4.792,0,6.781-9.896,6.844	c-2.906-0.625-9.625-4.583-17.917-10.229c3.01-0.333,5.229-0.5,6.479-0.5C357.094,330.667,361.563,332.208,362.667,334.552z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </span>
                    <a
                      class="
                        p-3
                        position-relative
                        d-flex
                        justify-content-between
                      "
                      v-bind:href="resource"
                      target="_blank"
                    >
                      <h5
                        style="word-break: break-all; font-size: 14px"
                        class="mb-0"
                      >
                        {{ getFileName(resource) }}
                      </h5>
                      <span class="download-icon px-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="20"
                          viewBox="0 0 14 20"
                        >
                          <path
                            id="download.svg"
                            class="cls-1"
                            fill="#19a883"
                            d="M3350.71,1232.66l-5.96,5.97c-0.01.01-.01,0.02-0.02,0.03a0.069,0.069,0,0,1-.06.07,0.994,0.994,0,0,1-.62.26h-0.03c-0.01,0-.01.01-0.02,0.01a0.01,0.01,0,0,1-.01-0.01,0.433,0.433,0,0,1-.05-0.01,0.891,0.891,0,0,1-.52-0.21,0.517,0.517,0,0,1-.13-0.06,0.247,0.247,0,0,1-.04-0.09c-0.01-.01-0.02-0.01-0.03-0.02l-5.93-5.94a0.96,0.96,0,0,1,0-1.38,0.978,0.978,0,0,1,1.38,0l4.33,4.34V1224a1,1,0,0,1,2,0v11.62l4.33-4.34a0.978,0.978,0,0,1,1.38,0A0.96,0.96,0,0,1,3350.71,1232.66ZM3339,1241h10a1,1,0,0,1,0,2h-10A1,1,0,0,1,3339,1241Z"
                            transform="translate(-3337 -1223)"
                          />
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!----tab content end---->
        </div>
      </div>
    </section>

    <div
      id="RetryJoinInZoom"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 20px; font-weight: 600; color: #1e1f26">
                Please try again.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="cancelRetryJoinInZoom"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="retryJoinInZoom"
                  >Retry</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../components/firebaseInit";
import APIs from "@/components/APIInit";
import RoundTable from "@/components/RoundTable.vue";
import axios from "axios";
//import TopMenu from "@/components/TopMenu.vue";
import jQuery from "jquery";
import store from "../store";
import analytics from "@/components/Analytics";
import router from "../router";
import common from "@/common";
import { bus } from "../main";
//import router from '../router';

let $ = jQuery;
var vm;
export default {
  name: "SponsorDetails",
  components: {
    //TopMenu,
    RoundTable,
  },

  data() {
    return {
      APIs: APIs,
      isBookmarked: false,
      IsShowEmailIcon: false,
      IsShowMobileIcon: false,
      IsShowWebsiteIcon: false,

      IsShowDescriptionTab: false,
      IsShowContactsTab: false,
      IsShowResources: false,
      currentTab: "",
      id: null,
      Name: null,
      BoothNo: null,
      Category: null,
      Email: null,
      Website: null,
      Image: null,
      Profile: null,
      Phone: null,
      MappedContacts: [],
      MappedRoundTables: [],
      allRoundTables: [],
      roundtableSettings: {
        // isSpeakerTabVisible: false,
        // isAttendeeTabVisible: false,
        // isQnATabVisible: false,
        // isChatTabVisible: false,
        // isRaiseHandTabVisible: false,
        HostLegend: "",
        SeatGrabText: this.$t("livestage.grabseat"),
        AllowAudienceViewText: this.$t("livestage.spectate"),
        TableFullText: this.$t("livestage.tablefull"),
        // ShowFilter: false,
        // ShowSearch: false,

        // AllowScreenShare: false,
        // AllowRecording: false,
      },
      GlobalKeysData: {
        // id: "SN1591285924312",
        // Name: "Opening Key Note",
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
      },
      facebook: "",
      linkedIn: "",
      twitter: "",
      instagram: "",
      Resources: [],
      defaultLogo:
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Fdefault_sponser_logo.png?alt=media",
      headerText: this.$t("sponsors.sponsors"),
      sponsorId: "",
      clientId: "",
      eventId: "",
      zoomErrorMsg:
        "An error has occurred with this Zoom live panel session. Please try again in sometime.",
      RestrictedZoomMeetingEnabled: true,
      tempTable: null,
      uid: "",
      email: "",
      name: "",
      firstName: "",
      lastName: "",
      phone: "",
      company: "",
      title: "",
      event_collectionName: "",
      rtSettings: {
        SeatGrabText: this.$t("livestage.grabseat"),
        AudienceViewText: this.$t("livestage.spectate"),
        TableFullText: this.$t("livestage.tablefull"),
      },
    };
  },
  watch: {
    "$route.query": function (val) {
      if (val.sid) {
        this.callMount();
      }
    },
  },
  created() {
    vm = this;
    vm.screenWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      vm.screenWidth = window.innerWidth;
    });
    vm.uid = vm.getSessionUserId();
    vm.visitor = vm.isVisitor();
    vm.event_collectionName = vm.getEventCollectionName();
  },
  beforeDestroy() {
    vm.disposeRoundTableListener();
  },
  async mounted() {
    this.callMount();
  },
  methods: {
    async callMount() {
      debugger;
      store.commit("addSponsorDetails", true);
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      common.toggleTopMenu(true);
      common.toggleLeftMenu(true);
      //$("#topmenu").show();
      //$("#leftmenu").show();
      $("#btnAddUserView").click();
      vm = this;
      vm.scroll();
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj) {
        vm.clientId = obj.client[0].id;
        vm.eventId = obj.eventid;

        if (obj.user && obj.user.length > 0) {
          vm.uid = obj.user[0].id;
          vm.name = obj.user[0].name;
          vm.email = obj.user[0].Email;
          vm.firstName = obj.user[0].fname;
          vm.lastName = obj.user[0].lname;
          vm.phone = obj.user[0].phone;
          vm.company = obj.user[0].company;
          vm.title = obj.user[0].title;
        }

        vm.postLeaderboardAction("SRBV");
      }
      console.log(obj.EventBranding[0].eventBGImage);
      $("#sectionId").css(
        "background-image",
        "url(" + obj.EventBranding[0].eventBGImage + ")"
      );
      //-------------dynamic font selection --------------------------------------
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          debugger;
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
      //-------------dynamic font selection --------------------------------------

      //-------Page Title-------------

      db.collection(obj.eventcollectionname)
        .doc("Menu")
        .get()
        .then((doc) => {
          var data = doc.data();
          $.each(data.LeftMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Sponsors") {
                if (vm.$store.state.locale == "English") {
                  vm.headerText = value.DisplayLabel;
                } else if (vm.$store.state.locale == "German") {
                  vm.headerText = value.DisplayLabel_de;
                } else if (vm.$store.state.locale == "French") {
                  vm.headerText = value.DisplayLabel_fr;
                } else if (vm.$store.state.locale == "Chinese") {
                  vm.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  vm.headerText = value.DisplayLabel_es;
                } else {
                  vm.headerText = value.DisplayLabel;
                }
                document.title = vm.headerText + " - " + obj.eventname;
                //document.getElementById("headerText").innerText = vm.headerText;
              }
            }
          });
          $.each(data.AllMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Sponsors") {
                if (vm.$store.state.locale == "English") {
                  vm.headerText = value.DisplayLabel;
                } else if (vm.$store.state.locale == "German") {
                  vm.headerText = value.DisplayLabel_de;
                } else if (vm.$store.state.locale == "French") {
                  vm.headerText = value.DisplayLabel_fr;
                } else if (vm.$store.state.locale == "Chinese") {
                  vm.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  vm.headerText = value.DisplayLabel_es;
                } else {
                  vm.headerText = value.DisplayLabel;
                }
                document.title = vm.headerText + " - " + obj.eventname;
                document.getElementById("headerText").innerText = vm.headerText;
              }
            }
          });
        });
      //-------------------FAVICONJOB------------------------------------------------------------
      debugger;
      if (obj.branding[0].favicon != undefined) {
        if (obj.branding[0].favicon != "") {
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = obj.branding[0].favicon;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
      //----------------------------------------------------------------------------------
      /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var brandingData;
      try {
        brandingData = await vm.getBrandingJSONDetails(
          obj.eventcollectionname + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          if (brandingData.data.EventInfo != undefined) {
            if (brandingData.data.EventInfo.BodyTextColor != undefined) {
              vm.textColor = brandingData.data.EventInfo.BodyTextColor;
            } else {
              vm.textColor = "black";
            }
          } else {
            vm.textColor = "black";
          }
          console.log("BodyTextColor :- " + vm.textColor);
          $("#headerText").css("color", vm.textColor);
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }
      //------------------------------------------------------------------------------
      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);

      //vm.setFirebaseAppsettings();

      if (this.$route.params.sid != undefined) {
        vm.sponsorId = this.$route.params.sid;
        store.commit("addSponsorID", vm.sponsorId);
      } else {
        var obj1 = JSON.parse(window.localStorage.getItem("my-app"));
        vm.sponsorId = obj1.selSponsorID;
      }

      if (!vm.sponsorId) {
        router.push("/sponsors");
      } else {
        vm.fetchSponserDetails();
      }
    },
    async addBookMark() {
      if (vm.visitor) {
        common.openRegistrationDialog();
        return;
      }
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 5,
          entityName: this.Name,
          entityImage: this.Image ? this.Image : "",
          entityId: this.id,
          entityLink: this.$route.path,
        },
      };
      if (this.isBookmarked) {
        this.isBookmarked = false;
        axios({
          method: "post",
          url: vm.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            this.isBookmarked = false;
          })
          .catch(() => {
            this.isBookmarked = true;
          });
      } else {
        this.isBookmarked = true;
        axios({
          method: "post",
          url: vm.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            this.isBookmarked = true;
          })
          .catch(() => {
            this.isBookmarked = false;
          });
      }
    },
    getInitials: function (str) {
      // alert(str);
      //var str = "Java Script Object Notation";
      var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      var acronym = "";
      if (matches != null) {
        acronym = matches.join(""); // JSON
      }
      return acronym;
      //console.log(acronym);
    },
    getFileName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    hideModal: function () {
      this.$refs["my-modal"].hide();
    },
    CloseModal: function () {
      $("#modalOpenBroadcast").modal("hide");
      $("#iframeBroadcast").attr("src", "");
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              analytics.AddUserAction(
                vm.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          analytics.AddUserAction(
            vm.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    scroll: function () {
      window.onscroll = () => {
        //alert("scroll");
        if (!vm.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            //this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
    fetchSponserDetails() {
      vm.allRoundTables = [];
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log("EventColName : " + obj.eventcollectionname);
      var sponserDetails = db
        .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
        .doc("SponsorList")
        .collection("Sponsors")
        .doc(vm.sponsorId);
      sponserDetails.get().then(async function (doc) {
        if (doc.exists) {
          (vm.id = doc.id),
            (vm.Name = doc.data().Name),
            (vm.BoothNo = doc.data().BoothNo),
            (vm.Category = doc.data().Category),
            (vm.Email = doc.data().Email),
            (vm.Website = doc.data().Website),
            (vm.Profile = doc.data().Profile),
            (vm.Phone = doc.data().Phone),
            (vm.Image = vm.getCDNUrl(doc.data().Logo)),
            (vm.MappedContacts = doc.data().MappedContacts),
            (vm.contactcount = doc.data().MappedContacts.length),
            (vm.MappedRoundTables = doc.data().MappedRoundTables),
            (vm.Files = doc.data().Files != undefined ? doc.data().Files : []),
            (vm.fileLength =
              doc.data().Files != undefined ? doc.data().Files.length : 0),
            (vm.Resources =
              doc.data().Resources != undefined ? doc.data().Resources : []),
            (vm.IsShowEmailIcon = doc.data().Email != "" ? true : false),
            (vm.IsShowMobileIcon = doc.data().Phone != "" ? true : false),
            (vm.IsShowWebsiteIcon = doc.data().Website != "" ? true : false),
            (vm.IsShowDescriptionTab = doc.data().Profile != "" ? true : false),
            (vm.IsShowContactsTab =
              doc.data().MappedContacts.length > 0 ? true : false),
            (vm.IsShowResources =
              doc.data().Resources.length > 0 ? true : false),
            console.log("data=====", doc.data());
          if (vm.IsShowResources) {
            vm.currentTab = "resources";
          }
          if (vm.IsShowContactsTab) {
            vm.currentTab = "contacts";
          }
          if (vm.IsShowDescriptionTab) {
            vm.currentTab = "description";
          }
          doc.data().SocialLinks.map((row) => {
            console.log("row=====", row);
            if (row.Facebook != undefined) {
              vm.facebook = row.Facebook;
            } else if (row.GooglePlus != undefined) {
              vm.instagram = row.GooglePlus;
            } else if (row.LinkedIn != undefined) {
              vm.linkedIn = row.LinkedIn;
            } else if (row.Twitter != undefined) {
              vm.twitter = row.Twitter;
            }
          });
          //alert(vm.MappedRoundTables.length);
          var i;
          for (i = 0; i < vm.MappedRoundTables.length; i++) {
            vm.getRoundTable(vm.MappedRoundTables[i].TableId);
          }

          if (vm.MappedRoundTables.length == 0) {
            $("#dvMainRoundTable").hide();
            $("#round-table-tooltip").hide();
          } else {
            $("#dvMainRoundTable").show();
            $("#round-table-tooltip").show();
          }
          let rqstData = {
            key: {
              instanceId: "OA_UAT",
              clientId: vm.$store.state.client[0].id,
              eventId: vm.$store.state.eventid,
            },
            data: {
              eventName: vm.$store.state.eventname,
              enetityUserId: vm.$store.state.userId,
              attendeeId: vm.$store.state.userId,
              entityType: 5,
              entityName: vm.Name,
              entityImage: vm.Image ? vm.Image : "",
              entityId: vm.id,
            },
          };
          try {
            let bookmarkExists = await axios({
              method: "post",
              url: vm.APIs.BookmarkAPIConfig.Get,
              data: rqstData,
            });
            if (bookmarkExists.data && bookmarkExists.data.isPublished)
              vm.isBookmarked = true;
            else vm.isBookmarked = false;
          } catch (e) {
            console.log(e);
            vm.isBookmarked = false;
          }
        }
      });
      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 1000);
    },

    getRoundTable(id) {
      //id = "729000";
      vm.disposeRoundTableListener();
      vm.allRoundTables = [];
      if (vm.allRoundTables.length == 0) {
        $("#dvMainRoundTable").hide();
        $("#round-table-tooltip").hide();
      } else {
        $("#dvMainRoundTable").show();
        $("#round-table-tooltip").show();
      }
      db.collection(vm.event_collectionName)
        .doc("RoundTableList")
        .collection("RoundTables")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let table = doc.data();
            if (table.IsPublished) {
              table.Capacity = isNaN(table.Capacity) ? 12 : table.Capacity;
              table.Occupied = isNaN(table.Occupied)
                ? 0
                : table.Occupied < 0
                ? 0
                : table.Occupied;
              table.HostId = "";
              if (table.Host && table.Host.length > 0) {
                table.HostId = table.Host[0].AttendeeId;
              }
              table.CoHostId = "";
              if (table.CoHost) {
                table.CoHostId = table.CoHost.AttendeeId;
              }
              table.AttendeeType = 4;
              if (table.HostId == vm.uid) {
                table.AttendeeType = 1;
              } else if (table.CoHostId == vm.uid) {
                table.AttendeeType = 3;
              } else {
                var attendees = table.MappedAttendees.filter(function (
                  attendee
                ) {
                  return attendee.AttendeeId == vm.uid;
                });
                if (attendees.length > 0) {
                  table.AttendeeType = 3;
                }
              }
              if (!table.StreamingClient) {
                table.StreamingClient = "";
              }
              if (table.StreamingClient) {
                table.StreamingClient = table.StreamingClient.trim();
              }
              if (!table.StreamingClientLink) {
                table.StreamingClientLink = "";
              }
              if (table.StreamingClientLink) {
                table.StreamingClientLink = table.StreamingClientLink.trim();
              }
              table.TableType = 1;
              if (table.StreamingClient.toLowerCase() == "zoom") {
                //table.Capacity = 300;
                table.TableType = 0;
              }
              table.MePresent = false;
              table.HostPresent = false;
              //table.CoHostPresent = false;
              table.IsTableFull = false;
              table.JoinButtonLabel = vm.rtSettings.SeatGrabText;
              table.JoinButtonClass = "";
              if (
                table.AttendeeType < 4 ||
                !table.PreAssigned ||
                table.SpectatorEnabled
              ) {
                table.ShowHeader = true;
                table.ShowSeatAvailability = true;
                table.ShowFooter = true;
                vm.allRoundTables.push(table);
                vm.initTableListener();
              }
            }
          }
        }) //querySnapshot.forEach(doc =>  ENDING PART
        .catch((error) => {
          console.log(error);
        });
    },
    initTableListener: function () {
      vm.allRoundTables.map(function name(table) {
        if (table.StreamingClient.toLowerCase() == "zoom") {
          table.listener = db
            .collection(vm.event_collectionName)
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(table.TableId)
            .onSnapshot((doc) => {
              var table = doc.data();
              var tables = vm.allRoundTables.filter(function (t) {
                return t.TableId == table.TableId;
              });
              if (tables.length > 0) {
                tables[0].Occupied = table.Occupied;
                if (tables[0].Occupied < tables[0].Capacity) {
                  tables[0].IsTableFull = false;
                  tables[0].JoinButtonLabel = vm.rtSettings.SeatGrabText;
                  tables[0].JoinButtonClass = "";
                } else {
                  tables[0].IsTableFull = true;
                  tables[0].JoinButtonLabel = vm.rtSettings.TableFullText;
                  tables[0].JoinButtonClass = "rt-no-slots";
                }
              }
            });
        } else {
          var col_name =
            "/" +
            vm.event_collectionName +
            "/RoundTableList/RoundTables/" +
            table.TableId +
            "/Participances";
          table.listener = db
            .collection(col_name)
            .onSnapshot((querySnapshot) => {
              var members = [];
              var tableId;
              querySnapshot.forEach((doc) => {
                var participant = doc.data();
                tableId = participant.TableId;
                let attendeeType = 1;
                if (participant.AttendeeType) {
                  attendeeType = participant.AttendeeType;
                }
                if (
                  participant.IsActive &&
                  attendeeType > 0 &&
                  attendeeType < 4
                ) {
                  members.push(participant);
                }
              });
              vm.updateTable(tableId, members);
            });
        }
      });
    },
    updateTable: function (tableId, members) {
      let tables = vm.allRoundTables.filter(function (table) {
        return table.TableId == tableId;
      });
      if (tables.length > 0) {
        //alert("" + tableId);
        let table = tables[0];
        //if (table.TableId == "4124000") {
        //  debugger;
        //}
        table.Occupied = members.length;
        var ids = members.filter(function (member) {
          return member.AttendeeId == table.HostId;
        });
        if (ids.length > 0) {
          table.HostPresent = true;
          //} else if (table.HostId != vm.uid) {
          //  table.Occupied++;
        }
        if (table.Occupied > table.Capacity) {
          table.Occupied = table.Capacity;
        }
        //ids = members.filter(function (member) {
        //  return member.AttendeeId == table.CoHostId;
        //});
        //if (ids.length > 0) {
        //  table.CoHostPresent = true;
        //}
        ids = members.filter(function (member) {
          return member.AttendeeId == vm.uid;
        });
        if (ids.length > 0) {
          table.MePresent = true;
        }
        ids = members.filter(function (member) {
          return (
            member.AttendeeId != table.HostId &&
            //member.AttendeeId != table.CoHostId &&
            member.AttendeeId != vm.uid
          );
        });
        let vacant = table.Capacity;
        if (table.HostId != vm.uid) {
          vacant--;
        }
        //if (table.CoHostId) {
        //  vacant--;
        //}
        vacant -= ids.length;
        table.JoinButtonLabel = vm.rtSettings.SeatGrabText;
        table.JoinButtonClass = "";
        table.IsTableFull = false;
        if (table.HostId == vm.uid) {
          //Join As Host
          //} else if (table.CoHostId == vm.uid) {
          //  //Join As CoHost
        } else if (table.PreAssigned) {
          if (table.AttendeeType == 3) {
            //Join As Speaker
          } else if (table.SpectatorEnabled) {
            //Join As Audience
            table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
            table.JoinButtonClass = "rt-spectate";
          }
        } else if (table.MePresent) {
          //Already Joined
        } else if (vacant > 0) {
          //Join As Speaker
        } else if (table.SpectatorEnabled) {
          //Join As Audience
          table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
          table.JoinButtonClass = "rt-spectate";
          //alert("spectate");
        } else {
          table.IsTableFull = true;
          table.JoinButtonLabel = vm.rtSettings.TableFullText;
          table.JoinButtonClass = "rt-no-slots";
        }
        vm.allRoundTables = vm.allRoundTables.filter(function () {
          return true;
        });
      }
    },
    disposeRoundTableListener() {
      vm.allRoundTables.map(function (item) {
        if (item.listener) {
          item.listener();
        }
        item.listener = null;
      });
    },
    getRoundTable1(id) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("RoundTableList")
        .collection("RoundTables")
        .where("TableId", "==", id)
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //--------------------------------
            var isMappedasAttendee = false;
            var isHost = false;
            var hostId = "0";
            var preassinedAtt = doc.data().MappedAttendees;
            var preAssisgnedAtt = preassinedAtt.filter(function (value) {
              return value.AttendeeId == vm.uid;
            });
            if (preAssisgnedAtt.length > 0) {
              isMappedasAttendee = true;
            }
            var host = doc.data().Host;
            if (host != undefined) {
              if (host.length > 0) {
                hostId =
                  host[0].AttendeeId == undefined ? "0" : host[0].AttendeeId;
                if (
                  host[0].AttendeeId != undefined &&
                  host[0].AttendeeId == vm.uid
                ) {
                  isHost = true;
                }
              }
            }

            var tbObj = new Object();
            tbObj.topicVisibility = true;
            tbObj.id = doc.id;
            //alert(querySnapshot.docs.length);
            tbObj.id = doc.id;
            tbObj.TableId = doc.data().TableId;
            tbObj.hostId = hostId;
            console.log(doc.id + "HostId:- " + hostId);
            tbObj.Name = doc.data().TableName;
            tbObj.Occupied = doc.data().Occupied;
            tbObj.Capacity = isNaN(doc.data().Capacity)
              ? 12
              : doc.data().Capacity;
            tbObj.BroadcastID = vm.GlobalKeysData.BroadcastID;
            tbObj.BroadcastCertificat = vm.GlobalKeysData.BroadcastCertificate;
            tbObj.BroadcastSpeakerApiUrl =
              vm.GlobalKeysData.BroadcastSpeakerApiUrl;
            tbObj.BroadcastAttendeeApiUrl =
              vm.GlobalKeysData.BroadcastAttendeeApiUrl;
            tbObj.BroadcastStartURL = vm.GlobalKeysData.BroadcastStartURL;
            tbObj.BroadcastViewURL = vm.GlobalKeysData.BroadcastViewURL;
            tbObj.BroadcastvalidityHours =
              vm.GlobalKeysData.BroadcastvalidityHours;
            tbObj.ChannelPrefix = vm.GlobalKeysData.ChannelPrefix;
            tbObj.IsHost = isHost;
            tbObj.IsMappedasAttendee = isMappedasAttendee;
            tbObj.PreAssigned = doc.data().PreAssigned;
            tbObj.SpectatorEnabled = doc.data().SpectatorEnabled;
            tbObj.IsTblVisible = true; //false;
            tbObj.IsVisible = true; //false;
            tbObj.IsTableFull = false;
            //tbObj.imgsrc = img;
            tbObj.imgsrc =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              tbObj.Capacity +
              "%2F01.jpg?alt=media";
            tbObj.StreamingClient = "";
            tbObj.StreamingClientLink = "";
            if (
              doc.data().StreamingClient &&
              doc.data().StreamingClient.trim() != ""
            ) {
              tbObj.StreamingClient = doc.data().StreamingClient.trim();
            }
            if (
              doc.data().StreamingClientLink &&
              doc.data().StreamingClientLink.trim() != ""
            ) {
              tbObj.StreamingClientLink = doc.data().StreamingClientLink.trim();
            }
            if (tbObj.StreamingClient.toLowerCase() == "zoom") {
              //tbObj.Capacity = 16;
              tbObj.Zoom_Detail = doc.data().Zoom_Detail;
            }

            vm.allRoundTables.push(tbObj);
          });
          vm.getTblTest();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTblTest: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      for (var j = 0; j < vm.allRoundTables.length; j++) {
        var col_name =
          "/" +
          obj.eventcollectionname +
          "/RoundTableList/RoundTables/" +
          vm.allRoundTables[j].id +
          "/Participances";
        db.collection(col_name)
          // .where("IsActive", "==", true)
          .onSnapshot((querySnapshot) => {
            // console.log("listner callded");
            debugger;
            //if (querySnapshot.docs.length > 0) {
            //  var ftid = querySnapshot.docs[0].data().TableId;
            //  var tblList = vm.allRoundTables.filter(function (item) {
            //    // alert(item.id);
            //    // alert(ftid);
            //    return item.id == ftid;
            //  });
            //  debugger;
            //  if (tblList.length > 0) {
            //    capa = tblList[0].Capacity;
            //  }
            //}
            var members = [];
            var curtbId;
            let iAmInTheTable = false;
            querySnapshot.forEach((doc) => {
              var participant = doc.data();
              // console.log(curDoc);
              curtbId = participant.TableId;
              let attType = 1;
              if (
                participant.AttendeeType != undefined &&
                participant.AttendeeType != null
              ) {
                attType = participant.AttendeeType;
              }
              if (participant.IsActive && attType > 0 && attType < 4) {
                if (participant.AttendeeId == vm.userid) {
                  iAmInTheTable = true;
                }
                members.push(participant);
              }
              //if (participant.IsActive) {
              //  members.push(participant);
              //}
            });
            //alert("capa " + capa);
            vm.updateSinglTable(curtbId, members, iAmInTheTable);
            //console.log(members);
          });
      }
    },
    updateSinglTable: function (curtbId, members, iAmInTheTable) {
      // var cnt = members.length;
      // console.log(cnt);
      var img = "";
      for (var i = 0; i < vm.allRoundTables.length; i++) {
        if (vm.allRoundTables[i].id == curtbId) {
          //if (curtbId == "2028000") {
          //  alert(iAmInTheTable);
          //}
          let table = vm.allRoundTables[i];
          var filteredIds = members.filter(function (value) {
            return value.AttendeeId != table.hostId && value.IsActive == true;
          });
          let Capacity = table.Capacity;
          //------------------------------------------------------------------------------------------------------------------------------------------------
          var cnt = filteredIds.length + 1;

          /*============================================================================================================================================== */
          // Capacity = 5;
          if (curtbId == "526000") {
            //     debugger;
            console.log("count:- " + cnt);
          }
          if (cnt < 1) {
            cnt = 1;
          } else if (cnt > Capacity) {
            cnt = Capacity;
          }

          if (filteredIds.length == members.length) {
            //host inactive
            if (cnt == undefined || cnt <= 0) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 1) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 2) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 3) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 4) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 5) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 6) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 7) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 8) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 9) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 10) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 11) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F11.jpg?alt=media&token=802d8c4a-0c26-4493-a111-dc95d659b6a5";
            } else if (cnt == 12) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F12.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 13) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F13.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 14) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F14.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 15) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F15.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt >= 16) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F16.jpg?alt=media";
            }
          } else {
            //host active
            if (cnt == undefined || cnt <= 0) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 1) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 2) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 3) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 4) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 5) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 6) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 7) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 8) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 9) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 10) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 11) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F11.jpg?alt=media&token=1d49ccca-4d81-4d53-bf95-b635598bc0a8";
            } else if (cnt == 12) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F12.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 13) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F13.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 14) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F14.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 15) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F15.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt >= 16) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F16.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            }
          }

          if (table.id == "729000") {
            //  debugger;
          }
          var tableLabel = vm.roundtableSettings.SeatGrabText; // "GRAB A SEAT";//dynamic settings
          var LabelCss = "grab-a-seat";
          var showTable = false;
          var IsTableFull = false;
          if (table.IsHost) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.PreAssigned) {
            if (table.IsMappedasAttendee) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Speaker
              showTable = true;
            } else if (table.SpectatorEnabled) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Audience
              showTable = true;
              tableLabel = vm.roundtableSettings.AllowAudienceViewText; // "SPECTATE";//dynamic settings
              LabelCss = "spectate";
            }
          } else if (iAmInTheTable) {
            showTable = true;
          } else if (cnt < table.Capacity) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.SpectatorEnabled) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Audience
            showTable = true;
            tableLabel = vm.roundtableSettings.AllowAudienceViewText; //"SPECTATE";//dynamic settings
            LabelCss = "spectate";
            //alert("spectate");
          } else {
            showTable = true;
            IsTableFull = true;
            tableLabel = vm.roundtableSettings.TableFullText; //"TABLE FULL";//dynamic settings
            LabelCss = "table-full";
          }

          /*========================================================================================================== */
          table.IsTableFull = IsTableFull;
          table.IsVisible = showTable;
          table.IsTblVisible = showTable && table.topicVisibility;
          //table.IsTblVisible = table.topicVisibility;
          table.tableLabel = tableLabel;
          table.imgsrc = img;
          table.LabelCss = LabelCss;
          console.log(img);
          break;
        }
      }
    },
    JoinRT(tableId) {
      if (!vm.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      // if (vm.visitor) {
      //   common.openRegistrationDialog();
      //   return;
      // }
      let tables = vm.allRoundTables.filter(function name(table) {
        return table.TableId == tableId && !table.IsTableFull;
      });
      if (tables.length > 0) {
        let table = tables[0];
        if (table.StreamingClient.toLowerCase() == "zoom") {
          vm.tempTable = {
            tableId: tableId,
          };
          if (table.Zoom_Detail && table.Zoom_Detail.id) {
            if (vm.uid == table.HostId || vm.uid == table.CoHostId) {
              var hlink =
                table.Zoom_Detail.start_url +
                "&uname=" +
                vm.firstName.trim() +
                "%20" +
                vm.lastName.trim();
              window.open(hlink, "_blank");
              vm.postLeaderboardAction("RTSB");
            } else {
              if (!vm.RestrictedZoomMeetingEnabled) {
                var link =
                  table.Zoom_Detail.join_url +
                  "&uname=" +
                  vm.firstName.trim() +
                  "%20" +
                  vm.lastName.trim();
                window.open(link, "_blank");
                vm.postLeaderboardAction("RTSB");
              } else {
                bus.$emit("toggleLoader", true);
                let headers = {
                  Authorization: "Bearer " + vm.getSessionToken(),
                  "content-type": "application/json",
                };
                let requestData = {
                  email: vm.email,
                  name: vm.name,
                  first_name: vm.firstName,
                  last_name: vm.lastName,
                  meetingid: table.Zoom_Detail.id,
                  address: "",
                  phone: vm.phone,
                  industry: "",
                  org: vm.company,
                  job_title: vm.title,
                };
                axios
                  .post(APIs.AddAttendeesToZoom, requestData, {
                    headers: headers,
                  })
                  .then((response) => {
                    if (
                      response &&
                      response.data &&
                      response.data.status == 0 &&
                      response.data.data.id &&
                      response.data.data.join_url &&
                      response.data.data.join_url != ""
                    ) {
                      bus.$emit("toggleLoader", false);
                      window.open(response.data.data.join_url, "_blank");
                      vm.postLeaderboardAction("RTSB");
                    } else {
                      bus.$emit("toggleLoader", false);
                      vm.retryJoinInZoomPopup();
                    }
                  })
                  .catch((error) => {
                    bus.$emit("toggleLoader", false);
                    console.log(error);
                    vm.retryJoinInZoomPopup();
                  });
              }
            }
          } else {
            alert(vm.zoomErrorMsg);
            vm.rtLoading = false;
          }
        } else if (table.StreamingClient.toLowerCase() == "custom") {
          vm.postLeaderboardAction("RTSB");
          window.open(table.CustomLink, "_blank");
        } else {
          // if (
          //   screen.width < 767 &&
          //   vm.AgoraPlayerBrowserSupportInMobile == false
          // ) {
          //   router.push("/screeninfo");
          // } else if (
          //   screen.width >= 768 &&
          //   screen.width <= 1024 &&
          //   vm.AgoraPlayerBrowserSupportInIPad == false
          // ) {
          //   router.push("/screeninfo");
          // } else {
            router.push({
              path: "/livestage/" + table.TableId + "_rt",
            });
          // }
        }
      }
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal(
        {
          backdrop: "static",
        },
        "show"
      );
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (vm.tempTable) {
        vm.JoinRT(vm.tempTable.tableId);
      }
    },
    JoinTable: function (
      hostId,
      tableId,
      IsVisible,
      IsTableFull,
      StreamingClient,
      Zoom_Detail
    ) {
      if (IsVisible && !IsTableFull) {
        vm.GoForInternalPlayerRT(tableId, StreamingClient, Zoom_Detail, hostId);
      }
    },
    GoForInternalPlayerRT(tableId, StreamingClient, Zoom_Detail, hostId) {
      if (StreamingClient.toLowerCase() == "zoom") {
        vm.tempTable = {
          tableId: tableId,
          StreamingClient: StreamingClient,
          Zoom_Detail: Zoom_Detail,
          hostId: hostId,
        };
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var attendeeId = obj.user[0].id;
        var first_name = obj.user[0].fname;
        var last_name = obj.user[0].lname;
        if (Zoom_Detail && Zoom_Detail.id) {
          if (attendeeId == hostId) {
            var hlink =
              Zoom_Detail.start_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(hlink, "_blank");
            vm.postLeaderboardAction("RTSB");
          } else {
            if (!vm.RestrictedZoomMeetingEnabled) {
              var link =
                Zoom_Detail.join_url +
                "&uname=" +
                first_name.trim() +
                "%20" +
                last_name.trim();
              window.open(link, "_blank");
              vm.postLeaderboardAction("RTSB");
            } else {
              bus.$emit("toggleLoader", true);
              let headers = {
                Authorization: "Bearer " + vm.getSessionToken(),
                "content-type": "application/json",
              };
              let requestData = {
                email: vm.email,
                name: vm.name,
                first_name: vm.firstName,
                last_name: vm.lastName,
                meetingid: Zoom_Detail.id,
                address: "",
                phone: vm.phone,
                industry: "",
                org: vm.company,
                job_title: vm.title,
              };
              axios
                .post(APIs.AddAttendeesToZoom, requestData, {
                  headers: headers,
                })
                .then((response) => {
                  if (
                    response &&
                    response.data &&
                    response.data.status == 0 &&
                    response.data.data.id &&
                    response.data.data.join_url &&
                    response.data.data.join_url != ""
                  ) {
                    bus.$emit("toggleLoader", false);
                    window.open(response.data.data.join_url, "_blank");
                    vm.postLeaderboardAction("RTSB");
                  } else {
                    bus.$emit("toggleLoader", false);
                    vm.retryJoinInZoomPopup();
                  }
                })
                .catch((error) => {
                  bus.$emit("toggleLoader", false);
                  console.log(error);
                  vm.retryJoinInZoomPopup();
                });
            }
          }
        } else {
          alert(vm.zoomErrorMsg);
          vm.hideLoader();
        }
      } else {
        // if (screen.width < 767) {
        //   router.push("/screeninfo");
        // } else {
          var chId = tableId + "_sprt";
          $(".tooltip").tooltip("hide");
          router.push({ path: "/livestage/" + chId });
        // }
      }
    },
    onClickHandler(event) {
      debugger;
      // event.target is the clicked element object
      vm.AddAnalitics(event, "click");
      //vm.hideFilter();
    },
  },
};
</script>
